import React, { forwardRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import "./Calendarpicker.css";

function CalendarToday(props) {
  const { setDatePicker, inputname, inputDate, ChangesetValueDate } = props;
  const [startDate, setStartDate] = useState(null);
  const years = range(2024, 2051, 1); // Update to include up to 2050
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentDate = new Date(); // Get the current date
  const minSelectableDate = currentDate; // Set minDate to today
  const maxSelectableDate = new Date(2050, 11, 31); // Set maxDate to December 31, 2050

  useEffect(() => {
    if (inputDate === "") {
      setStartDate(null);
    }
  }, [inputDate]);

  const onSelected = (date) => {
    console.log('onselect',date)
    setStartDate(date);
    setDatePicker(inputname, date);
    ChangesetValueDate(date);
  };

  const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <div className="inp-calendar">
      <input
        value={value}
        className="custom-input-date"
        onClick={onClick}
        onChange={onChange}
        ref={ref}
        onFocus={(e) => {
          e.target.blur();
        }}
        placeholder={props.dataDate !== null ? props.dataDate : "dd/mm/yyyy"}
      />
    </div>
  ));

  return (
    <DatePicker
      className="inp-data01 fontReg font-size03 colorGray01"
      customInput={<CustomInput />}
      dateFormat="dd/MM/yyyy"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button>
          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(Number(value))}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
      )}
      placeholderText="dd/mm/yyyy"
      selected={startDate}
      onChange={(date) => onSelected(date)}
      calendarStartDay={5}
      minDate={minSelectableDate} // Set minimum selectable date
      maxDate={maxSelectableDate} // Set maximum selectable date
    />
  );
}

export default CalendarToday;